import * as ts from "typescript";

import * as GC from "@grapecity/spread-sheets";

import * as Handsontable from 'handsontable';

import { TableModule } from 'primeng/table';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule } from '@angular/forms';
import { Directive, ComponentFactoryResolver } from '@angular/core';
import { Component, ViewEncapsulation, ViewContainerRef, Compiler, NgModule, Pipe, PipeTransform,HostListener } from '@angular/core';
import {AtomSpinnerModule,PixelSpinnerModule,FingerprintSpinnerModule,
       CirclesToRhumbusesSpinnerModule,BreedingRhombusSpinnerModule,FlowerSpinnerModule,
       FulfillingBouncingCircleSpinnerModule,HalfCircleSpinnerModule,SelfBuildingSquareSpinnerModule
      ,} from 'angular-epic-spinners'

import { TokenInterceptor,PlotlyComponent,EsriMapComponent} from '../../helpers/index';
import { CommonModule } from '@angular/common';
import { BrowserModule, DomSanitizer  } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule,ActivatedRoute } from '@angular/router';

import { ApiService,AlertService,CanDeactivateGuard} from '../../services/';
import { HotTableModule } from '@handsontable/angular';

import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { CodemirrorModule } from 'ng2-codemirror';
import { ToastrModule, ToastrService } from 'ngx-toastr';

import { SpreadSheetsModule } from "@grapecity/spread-sheets-angular";

import { ChartsModule } from 'ng2-charts/ng2-charts';
import { Observable } from 'rxjs/Observable';
import 'chartjs-plugin-datalabels';
import 'chartjs-plugin-annotation';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxSelectModule } from 'ngx-select-ex';

import {SpringSpinnerModule} from 'angular-epic-spinners'

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';


import { User, DataTable, RequestParameter, UploadResponse, QueryStringParameter, NonQuery, SingleObject, DynamicPage, PageFunction, DictionaryItem,Alert, AlertType } from '../../models/data.types';
import { AceEditorModule } from 'ng2-ace-editor';
import { DataTablesModule } from 'angular-datatables';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { ModalModule } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/Rx';

import { MbscModule,mobiscroll, MbscCalendarOptions,MbscEventcalendarOptions } from '@mobiscroll/angular';

import 'brace/index';
import 'brace/theme/eclipse';
import 'brace/theme/monokai';
import 'brace/mode/markdown';
import 'brace/mode/javascript';
import 'brace/mode/sql';
import 'brace/ext/language_tools.js';

import 'codemirror/mode/go/go'
import 'codemirror/mode/sql/sql'
import 'codemirror/mode/htmlembedded/htmlembedded'
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/xml-fold';
import 'codemirror'
import { environment } from "environments/environment.prod";


declare var jquery:any;
declare var $ :any;



@Directive({
  selector: '[dynamicPage]'
})
export class DynamicPageDirective {
  constructor(
    private compiler: Compiler,
    private viewContainer: ViewContainerRef,
    private toastr: ToastrService
  ) { }

  /*  
  ngOnInit() {
    this.toastr.success('Hello world!', 'Toastr fun!');
  }*/


  addComponent(pageToLoad: DynamicPage, queryStringparams: QueryStringParameter[], isMainPage: boolean) {

  
    @Component({ template: pageToLoad.Template, encapsulation: ViewEncapsulation.Emulated })
    
    class TemplateComponent {
      
      isUploading: boolean;
      isBusy: boolean;
      message: string;
      pageBag: any = {};
      dynamicpage: DynamicPage = pageToLoad;
      functions: PageFunction[] = [];
      tables: DictionaryItem<string, DataTable>[] = [];

      unSavedData: boolean;
      doQueryResults: DictionaryItem<string, DataTable>[] = [];

      nonQueries: DictionaryItem<string, NonQuery>[] = [];
      objects: DictionaryItem<string, SingleObject>[] = [];
      alerts: Alert[] = [];
      queryParams : QueryStringParameter[];
      
      fileToUpload: File = null;
      fileToUploadContent: String = null;

      user : User;
      username : string;
      dtTrigger: Subject<any> = new Subject();
      dtTrigger1: Subject<any> = new Subject();
      dtTrigger2: Subject<any> = new Subject();
      dtTrigger3: Subject<any> = new Subject();
      dtTrigger4: Subject<any> = new Subject();
      dtTrigger5: Subject<any> = new Subject();
      
      mbSettings: MbscEventcalendarOptions ;
      mobiscrollObj = mobiscroll;

      GC = GC;
      Handsontable = Handsontable;

      hotSettings: {};
       
      codeMirrorOptions : any = {
        lineNumbers: true,
        mode: 'text/html', 
        foldGutter: true, 
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'] ,
        extraKeys: {
          "F11": function(cm) {
            cm.setOption("fullScreen", !cm.getOption("fullScreen"));
            console.log(cm.getOption("fullScreen"));
            console.log(cm);
          },
          "Esc": function(cm) {
            if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false);
            console.log(cm.getOption("fullScreen"));
          }
        }
      };

      constructor(
        private api: ApiService,
        private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastrService,
        private alertService: AlertService,
        private sanitizer: DomSanitizer) { }

      menuAdditionalConfig(event) {
        var existingClasses = event.target.attributes.class.value;
        var n = existingClasses.search(/fa-angle-up/i);
        if (n > 0) {
            event.target.attributes.class.value = "fa fa-angle-down pull-right";
        } else {
            event.target.attributes.class.value = "fa fa-angle-up pull-right";
        }              
      }   

      addToMenu() {
         var formURL  = document.getElementById("form-url");
         var formLinkText = document.getElementById("form-link-text");
         var isR = false;

         let formURLValue = (<HTMLInputElement>document.getElementById("form-url")).value;
         
         let formLinkTextValue = (<HTMLInputElement>document.getElementById("form-link-text")).value;

         if (formURLValue == '' || formURLValue == 'http://' || formURLValue == 'https://') {
            isR = true;
            formURL.classList.add("border-danger");
         } else {
            formURL.classList.remove("border-danger");
         }
         if (formLinkTextValue == '') {
            isR = true;
            formLinkText.classList.add("border-danger");
         } else {
            formLinkText.classList.remove("border-danger");
         }
         if (isR) {
            return false;
         }
        var innerForm = '<div class="form-group row menu-detail"><label for="url" class="col-sm-2 col-form-label">URL</label><div class="col-sm-4"><input type="text" class="form-control" id="url" value="http://"></div><label for="link-text" class="col-sm-2 col-form-label">Link Text</label><div class="col-sm-4"><input type="text" class="form-control" id="link-text"></div></div>'; 
        var opener = '<a href="javascript:void(0);" class="fa fa-angle-down pull-right" (click)="menuAdditionalConfig($event)"></a>';
        var html = '<li class="list-group-item list-group-item-secondary">'+formLinkTextValue+opener+innerForm+'</li>';
        var listG = document.getElementById('listGroup');
        listG.insertAdjacentHTML('afterend', html);
        formURLValue = "";
        formLinkTextValue = "";        
      }

      ngOnInit() {

      
       this.queryParams = queryStringparams;
       this.loadPage();
       
        this.alertService.getAlert().subscribe((alert: Alert) => {
          if (!alert) {
              this.alerts = [];
              return;
          }
          this.alerts.push(alert);
      });
      }

   @HostListener('window:beforeunload', ['$event'])
       public beforeunload($event) {
         if ($event != null)
         {
          if (localStorage["pageLocked"] === "1") {$event.returnValue = "Are you sure?";}
            
         }
           
    }

    @HostListener('window:unload', ['$event'])
        unloadHandler(event) {
          localStorage["pageLocked"] === "0";
        }

      trustSrcUrl = function(data){
        return this.sanitizer.bypassSecurityTrustResourceUrl(data);
      }

      loadPage() {

        this.api.get<PageFunction[]>('pages/getpagefunctionsbyroute/' + pageToLoad.Route).then(response => {

          this.functions = response;

          for (let f of this.functions) {
            if (f.ReturnTypeId == 1) { //void
              this.nonQueries[f.Name] = new NonQuery();
            }
            else if (f.ReturnTypeId == 2) { //dataTable
              this.tables[f.Name] = new DataTable();
            }
            else if (f.ReturnTypeId == 3) { //singleObject
              this.objects[f.Name] = new SingleObject();
            }
            else if (f.ReturnTypeId == 4) { //arrayObject
              this.objects[f.Name] = [];
            }
          }

          this.user = JSON.parse(localStorage.getItem('currentUser'));

          if (this.api.roles === undefined && this.user != null)
          {
            this.api.get<string[]>('account/getroles')
               .then(roles => {
                 this.api.roles = roles;
               });
          }

          this.username = this.user != null ? this.user.username : "";
          this.queryParams = queryStringparams;

          this.doInitFunctions();

          
          eval(pageToLoad.Script);

          if(isMainPage && localStorage["originalUser"] == null && this.user != null) 
          {
            
              let body = JSON.parse('{"UserName": "'+this.user.username+
                                  '","PageName":"'+pageToLoad.Name+
                                  '","PageRoute":"'+pageToLoad.Route+
                                  '","BaseURL":"'+document.URL +
                                  '","LogDateTime":"'+new Date().toLocaleString().replace(",","")+
                                  '","Browser":"'+navigator.appVersion+
                                  '","UserAgent":"'+navigator.userAgent+
                                  '","AcceptLanguage":"'+navigator.language+
                                  '","TokenUsed":"'+this.user.token+
                                  '"}');

              this.api.postAs<any>('data/doquery/AddUserPageViewLog/',body);

        }
        });
      }

      private doInitFunctions() {

        let fParams: RequestParameter[] = [];

        for (let f of this.functions) {
          if (f.OnLoad) {

            for (let p of f.Parameters) {

              for (let qsp of queryStringparams) {
                if (qsp.Name == p.Name && p.DefaultValue != null && p.DefaultValue.startsWith('?')) {
                  let rp = new RequestParameter();
                  rp.Name = qsp.Name;
                  rp.Value = qsp.Value;
                  fParams.push(rp);
                }
              }

            }

            if (fParams.length == 0 && f.Parameters.length > 0) {
              for (let p of f.Parameters) {
                if (p.DefaultValue != null) {
                  let rp = new RequestParameter();
                  rp.Name = p.Name;

                  if (p.DefaultValue.startsWith('$Global.')) {

                  }
                  else {
                    rp.Value = p.DefaultValue;
                  }
                  fParams.push(rp);
                }
              }
            }

            if (f.ReturnTypeId == 1) { //void
              console.log('init void ' + f.Name);
              this.nonQueries[f.Name].isBusy = true;
              this.nonQueries[f.Name].isLoading = true;

              if (f.BeforeExec != null) {
                eval(f.BeforeExec);
              }

              this.api.putAs<NonQuery>('functions/executeasnonquery/' + f.Id, fParams).then(response => {
                this.nonQueries[f.Name] = response;
                this.nonQueries[f.Name].isBusy = false;
                this.nonQueries[f.Name].isLoading = false;
                this.nonQueries[f.Name].isLoaded = true;

                if (f.OnSuccess != null) {
                  eval(f.OnSuccess);
                }
              })
                .catch(
                  () => {
                    if (f.OnError != null) {
                      eval(f.OnError);
                    }
                  });
            }
            else if (f.ReturnTypeId == 2) { //dataTable
              console.log('init dataTable ' + f.Name);
              this.tables[f.Name].isBusy = true;
              this.tables[f.Name].isLoading = true;

              if (f.BeforeExec != null) {
                eval(f.BeforeExec);
              }

              this.api.putAs<DataTable>('functions/executeasdatatable/' + f.Id, fParams).then(response => {
                if(f.Name == "CW_GetAllUsers")
                {
                  this.tables[f.Name] = JSON.parse( JSON.stringify(response).toLowerCase());
                }
                else
                {
                  this.tables[f.Name] = response;
                }
                
                this.tables[f.Name].isBusy = false;
                this.tables[f.Name].isLoading = false;
                this.tables[f.Name].isLoaded = true;

                if (f.OnSuccess != null) {
                  eval(f.OnSuccess);
                }
              })
                .catch(
                  () => {
                    if (f.OnError != null) {
                      eval(f.OnError);
                    }
                  });
            }
            else if (f.ReturnTypeId == 3) { //singleObject
              console.log('init singleObject ' + f.Name);
              this.objects[f.Name].isBusy = true;
              this.objects[f.Name].isLoading = true;

              if (f.BeforeExec != null) {
                eval(f.BeforeExec);
              }

              this.api.putAs<SingleObject>('functions/executeassingleobject/' + f.Id, fParams).then(response => {
                this.objects[f.Name] = response;
                this.objects[f.Name].isBusy = false;
                this.objects[f.Name].isLoading = false;
                this.objects[f.Name].isLoaded = true;

                if (f.OnSuccess != null) {
                  eval(f.OnSuccess);
                }
              })
                .catch(
                  () => {
                    if (f.OnError != null) {
                      eval(f.OnError);
                    }
                  });
            }
            else if (f.ReturnTypeId == 4) { //array
              console.log('init arrayObject ' + f.Name);
              this.objects[f.Name].isBusy = true;
              this.objects[f.Name].isLoading = true;

              if (f.BeforeExec != null) {
                eval(f.BeforeExec);
              }

              this.api.putAs<SingleObject>('functions/executeasarrayobject/' + f.Id, fParams).then(response => {
                this.objects[f.Name] = response;
                this.objects[f.Name].isBusy = false;
                this.objects[f.Name].isLoading = false;
                this.objects[f.Name].isLoaded = true;

                if (f.OnSuccess != null) {
                  eval(f.OnSuccess);
                }
              })
                .catch(
                  () => {
                    if (f.OnError != null) {
                      eval(f.OnError);
                    }
                  });
            }
          }
        }
      }

      do(functionName: string, o: any): Promise<boolean> {

        this.isBusy = true;
        let f = this.functions.find(x => x.Name == functionName);
        if (!f) {
          console.log('Function ' + functionName + ' was not found.');
          return;
        }

        console.log('do ' + f.Name);

        let fParams: RequestParameter[] = [];

        if (o != null) {
          for (let p of f.Parameters) {

            let rp = new RequestParameter();
            rp.Name = p.Name;

            let pval = Reflect.get(o, p.Name);

            if (pval) {
              console.log('setting ' + p.Name + ' = ' + pval);
              rp.Value = pval;
            }
            else {

              if (p.DefaultValue != null) {
                // if(p.DefaultValue.startsWith('$Global.')) {
                //     let gVal = this.getGlobal(p.DefaultValue);
                //     console.log('setting ' + p.Name + ' = ' + gVal);
                //     rp.Value = gVal;
                // }
              }

              console.log('setting ' + p.Name + ' = NULL');
            }

            fParams.push(rp);
          }
        }

        console.log('calling api');
        if (f.ReturnTypeId == 1) { //void
          this.nonQueries[f.Name].isBusy = true;
          this.nonQueries[f.Name].isLoading = true;

          if (f.BeforeExec != null) {
            eval(f.BeforeExec);
          }

          this.api.putAs<NonQuery>('functions/executeasnonquery/' + f.Id, fParams).then(response => {
            console.log("here is the response");
            console.log(response);
            this.nonQueries[f.Name] = response;
            this.nonQueries[f.Name].isBusy = false;
            this.nonQueries[f.Name].isLoading = false;
            this.nonQueries[f.Name].isLoaded = true;
            this.isBusy = false

            if (f.OnSuccess != null) {
              eval(f.OnSuccess);
            }
          })
            .catch(
              () => {
                if (f.OnError != null) {
                  eval(f.OnError);
                }
              });
        }
        else if (f.ReturnTypeId == 2) { //dataTable
          this.tables[f.Name].isBusy = true;
          this.tables[f.Name].isLoading = true;

          if (f.BeforeExec != null) {
            eval(f.BeforeExec);
          }

          this.api.putAs<NonQuery>('functions/executeasdatatable/' + f.Id, fParams).then(response => {
            console.log("here is the response");
            console.log(response);
            this.tables[f.Name] = response;
            this.tables[f.Name].isBusy = false;
            this.tables[f.Name].isLoading = false;
            this.tables[f.Name].isLoaded = true;
            this.isBusy = false;

            if (f.OnSuccess != null) {
              eval(f.OnSuccess);
            }
          })
            .catch(
              () => {
                if (f.OnError != null) {
                  eval(f.OnError);
                }
              });
        }
        else if (f.ReturnTypeId == 3) { //singleObject
          this.objects[f.Name].isBusy = true;
          this.objects[f.Name].isLoading = true;

          if (f.BeforeExec != null) {
            eval(f.BeforeExec);
          }

          this.api.putAs<SingleObject>('functions/executeassingleobject/' + f.Id, fParams)

            .then(
              response => {

                console.log("here is the response");
                console.log(response);
                this.objects[f.Name] = response;
                this.objects[f.Name].isBusy = false;
                this.objects[f.Name].isLoading = false;
                this.objects[f.Name].isLoaded = true;
                this.isBusy = false;

                if (f.OnSuccess != null) {
                  
                  eval(f.OnSuccess); 
                }
              })
            .catch(
              () => {
                if (f.OnError != null) {
                  eval(f.OnError);
                }
              });
        }
      }

      filterChartData(dataSource: any,filter : string )
      {

         let data = dataSource.filter(row => row.block === filter)
          
         return data;
      }

      getFilteredChartData(dataSource: any,filters : any[] )
      {
         var data : any

         data = dataSource.filter(function (item){

          if (filters.length == 1){

            return  item[filters[0].key] === filters[0].value ;

          }
          else if(filters.length == 2){

            return  item[filters[0].key] === filters[0].value && 
                  item[filters[1].key] === filters[1].value ;

          }
          else {

            return  item[filters[0].key] === filters[0].value && 
                  item[filters[1].key] === filters[1].value && 
                  item[filters[2].key] === filters[2].value;

            }
         })

        return data;
      }

      getArrayFromPagebag(pagebagsource : string,pagebagname:string,
                          collectionname:string,fieldname: string,
                          filterField: string){
        
        var returnedObject: {[key: string]: any} = {};
        var returnedArray = [];
        switch(pagebagsource) { 
          case "tables": { 
             var data = this.tables[pagebagname][collectionname]
             break; 
          } 
          case "objects": { 
            var data = this.objects[pagebagname][collectionname]
            break; 
          } 
          case "doQueryResults": { 
            var data = this.doQueryResults[pagebagname][collectionname]
            break; 
         } 
          default: { 
             break; 
        } 
       }
        data.forEach(element => {
          if(element[filterField] == "true" || element[filterField] == true)
          {
            returnedArray.push(element[fieldname])
          }
        });
        
        returnedObject[collectionname] = JSON.stringify(returnedArray).replace("[","").replace("]","").replace(/"/g, '');
        return returnedObject;
      }

      getArrayFromMultiDropDown(pagebagname:string,collectionname:string){

        var returnedObject: {[key: string]: any} = {};
        var returnedArray = [];

        var data = this.pageBag[pagebagname]
      
        data.forEach(element => {
       
          returnedArray.push(element["itemName"])
        
        });

        returnedObject[collectionname] = JSON.stringify(returnedArray).replace("[","").replace("]","").replace(/"/g, '');
        return returnedObject;
        }

      processChartFilterChange(pagebagsource : string,pagebagname:string,
        collectionname:string,changedValue: string, checked: boolean){

              var returnedObject: {[key: string]: any} = {};
              var returnedArray = [];
              switch(pagebagsource) { 
              case "tables": { 
                var data = this.tables[pagebagname][collectionname]
                break; 
              } 
              case "objects": { 
                var data = this.objects[pagebagname][collectionname]
                break; 
              } 
              case "doQueryResults": { 
                var data = this.doQueryResults[pagebagname][collectionname]
                break; 
              } 
              default: { 
                break; 
                } 
              }
              if(changedValue === "(All)" && checked) {
                data.forEach(element => {
                  element.Selected = true;
                });
              }
              else if (changedValue === "(All)" && !checked) {
                data.forEach(element => {
                  element.Selected = false;
                });
              }
              else{
                data.forEach(element => {
                  if (element.Year === "(All)") {
                    element.Selected = false;
                  }
                });
              }


      }

      doQuery(functionName: string, o: any,pageBagName : string) {

        this.isBusy = true;
    

        console.log('doQuery: ' +functionName);
        
        console.log('calling api');
        
        this.doQueryResults[pageBagName] = new DataTable();

        this.doQueryResults[pageBagName].isBusy = true;
        this.doQueryResults[pageBagName].isLoading = true;
      
        if (o.length >= 1)
        {
          let newO : any = new Object;
          let stringObject : string;
          o.forEach(element => {
            newO[Object.keys(element)[0]] = element[Object.keys(element)[0]];
          }); 
         o = newO;
        }
       return this.api.postAs<any>('data/doquery/' + functionName, o)
          .then(
            response => {
            
            console.log("here is the response");
            console.log(response);
            this.doQueryResults[pageBagName] = response;
            this.doQueryResults[pageBagName].isBusy = false;
            this.doQueryResults[pageBagName].isLoading = false;
            this.doQueryResults[pageBagName].isLoaded = true;
            this.isBusy = false;
      
            console.log("Response save to doQueryResults['"+pageBagName+"']");
          })
          .catch(() => {
                console.log(this.error)
         });
      }

      filtersToQueryParameters(o: any) {

        var queryParams: string = "";

        o.forEach(element => {
          queryParams +=  "&" + Object.keys(element)[0] + "=" + element[Object.keys(element)[0]] ;
        });
        return  queryParams;
      }


     sendEmail(receipents : string, subject : string , body: string , attachment : string, fileName : string)
      {
        this.isBusy = true;

        let emailData : any = {};
        emailData.email = receipents;
        emailData.subject = subject;
        emailData.body = body;

        if(attachment != null && attachment.length > 0)
        {
             let attachmentsList : any = []
             let attachmentData : any = {};
             attachmentData.key = attachment
             attachmentData.value = fileName
             
             attachmentsList.push(attachmentData)

             emailData.attachments = attachmentsList
        }
       
        this.api.postAs<any>('Admin/SendMail/',emailData).then(x => {
            this.isBusy = false;
            let alert : Alert = new Alert();

            if (x.Result != "success") {
              
              alert.type = AlertType.Error;
              alert.message = "Error Sending Report!";
            }
            else
            {
              alert.type = AlertType.Success;
              alert.message = "Report Sent!";
            }
            this.alerts.push(alert);
        });

     }

     handleFileInput(files: FileList) {
      this.fileToUpload = files.item(0);
      this.pageBag.FileToUploadName = this.fileToUpload.name;
      let reader = new FileReader();

      reader.readAsDataURL(this.fileToUpload);
      reader.onload = () => {
        
         this.fileToUploadContent =  (<string>reader.result).split(',')[1]
      
      };

    }

     closeModal(modalId : string)
     {
      $(modalId).modal('hide');
     }

     upload(fileArea:string,fileType:string) {

      const formData: FormData = new FormData();
      formData.append('fileKey', this.fileToUpload, this.fileToUpload.name);

        
       this.api.postAs<UploadResponse>('data/doupload',
             { Name: this.fileToUpload.name, 
               Size: this.fileToUpload.size, 
               Data: this.fileToUploadContent,
               FileArea: fileArea,
               FileType: fileType, 
               FilesFolderPath: environment.fileFolderPath,
               HttpPath: environment.httpPath,
               UserId : this.user != null ? this.user.username : "Anonymous"
             })
          .then(response => {
              console.log(response);
              if (response.HasError)
              {
                this.error(response.ErrorMessage);
              }
              else
              {
                this.success("File Uploaded");
                this.fileToUploadContent = null;
              }

              this.isUploading = false;
            });
     }

     open(url: string, params: any) {

        let pArray = Reflect.ownKeys(params);

        pArray.forEach(element => {
          url += '&' + element.toString() + '=' + Reflect.get(params, element.toString());
        });

        window.open(url);
     }

     openExcelUrl(url: string) {
      window.open(url);
   }

     getDate() {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();

        var day = date.getDate();
        var dayString = '';
        var month = date.getMonth() + 1;
        var monthString = '';
        var year = date.getFullYear();
        if (month < 10)
          monthString = '0' + month.toString();
        else
          monthString = month.toString();
        if (day < 10)
          dayString = '0' + day.toString();
        else
          dayString = day.toString();
        var dateString = year + '-' + monthString + '-' + dayString;

        return dateString;
     }

     getFirstDateOfMonth() {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        var firstDay = new Date(y, m, 1);

        var day = firstDay.getDate();
        var dayString = '';
        var month = firstDay.getMonth() + 1;
        var monthString = '';
        var year = firstDay.getFullYear();
        if (month < 10)
          monthString = '0' + month.toString();
        else
          monthString = month.toString();
        if (day < 10)
          dayString = '0' + day.toString();
        else
          dayString = day.toString();
        var dateString = year + '-' + monthString + '-' + dayString;

        return dateString;
     }

     logout() {
        console.log('Logging out...');

        this.api.logout().toPromise()
          .then(x => {
            this.api.isLoggedIn = false;
            this.router.navigate(['/app/home']);
          });
     }

     login(username: string, password: string) {
        this.isBusy = true;

        if (this.pageBag.UseADLogin != null && this.pageBag.UseADLogin == 1 )
        {
          this.api.adLogin(username, password).then(x => {
            this.isBusy = false;
 
           if (x.error != null) {
             this.message = x.error.ExceptionMessage;
           }
           else {
 
             let session = JSON.parse(JSON.stringify(x));
 
             this.user = new User();
             this.user.username = username;
             this.user.password = password;
             this.user.token = session.access_token.toString();
             this.user.LoginType ="AD";
             localStorage.setItem('currentUser', JSON.stringify(this.user));

             
             this.api.get<string[]>('account/getroles')
             .then(roles => {
               this.api.roles = roles;
               this.user.isDeveloper =  roles.indexOf("Developer") > -1;
               let body = '{"email": "'+this.user.username +'"}'
               this.api.postAs<any>('data/doquery/CW_GetUserProfileId',JSON.parse(body)).then(
                 response => {
           
                   this.user.ProfileId = response.Item.profileid;
                   this.user.ProfileName = response.Item.profilename;
                     
                   localStorage.setItem('currentUser', JSON.stringify(this.user));

                   if(this.router.url.indexOf('?returnUrl') > -1)
                   {
                     this.route.queryParams.subscribe (x => {
                       this.router.navigate([x.returnUrl]);
                     })
                   }
                   else{
                     this.router.navigate(['/home']);
                   }
                 });
             });
           }
         });
        }
        else
        {
           this.api.login(username, password).then(x => {
           this.isBusy = false;

          if (x.error != null) {
            this.message = "Invalid Credentials!";x.error.error_description;
          }
          else {

            let session = JSON.parse(JSON.stringify(x));

            this.user = new User();
            this.user.username = username;
            this.user.password = password;
            this.user.token = session.access_token.toString();
            this.user.LoginType ="ScheidNet";

            localStorage.setItem('currentUser', JSON.stringify(this.user));

              this.api.get<string[]>('account/getroles')
              .then(roles => {
                this.api.roles = roles;
                this.user.isDeveloper =  roles.indexOf("Developer") > -1;
                let body = '{"email": "'+this.user.username +'"}'
                this.api.postAs<any>('data/doquery/CW_GetUserProfileId',JSON.parse(body)).then(
                  response => {
            
                    this.user.ProfileId = response.Item.profileid;
                    this.user.ProfileName = response.Item.profilename;
                      
                    localStorage.setItem('currentUser', JSON.stringify(this.user));

                    if(this.router.url.indexOf('?returnUrl') > -1)
                    {
                      this.route.queryParams.subscribe (x => {
                        this.router.navigate([x.returnUrl]);
                      })
                    }
                    else{
                      this.router.navigate(['/home']);
                    }
                  });
              });
            
          }
        });
      }

     }

     changeLoggedInUser(username: any){

        let originalUser : User
        if(localStorage["originalUser"] == null)
        {
           originalUser = JSON.parse(localStorage.getItem("currentUser"));
           localStorage.setItem("originalUser",JSON.stringify(originalUser));
        }
        else
        {
          originalUser = JSON.parse(localStorage.getItem('originalUser'));
        }
             
  
        this.api.get<any>('Account/LoginAs?userName='+username).then(
          response => {
            let session = JSON.parse(JSON.stringify(response));
  
            this.user = new User();
            this.user.username = username;
            this.user.password = "";
            this.user.token = session.accessToken.toString();
            this.user.isDeveloper = originalUser.isDeveloper;
  
            localStorage.setItem('currentUser', JSON.stringify(this.user));
  
            window.location.reload();
        })
  
     }

     success(message: string) { 
        this.alertService.success(message);
     }
   
     error(message: string) {
        this.alertService.error(message);
     }

     info(message: string) {
        this.alertService.info(message);
     }

     warn(message: string) {
        this.alertService.warn(message);
     }
     
     clear() {
        this.alertService.clear();
     }

    removeAlert(alert: Alert) {
        this.alerts = this.alerts.filter(x => x !== alert);
      }

    cssClass(alert: Alert) {
          if (!alert) {
              return;
          }

          // return css class based on alert type
          switch (alert.type) {
              case AlertType.Success:
                  return 'alert alert-success';
              case AlertType.Error:
                  return 'alert alert-danger';
              case AlertType.Info:
                  return 'alert alert-info';
              case AlertType.Warning:
                  return 'alert alert-warning';
          }
      }

    canDeactivate(): Observable<boolean> | boolean {
        if (!this.unSavedData) {
           this.toastr.info('Please save your changes before changing the schedule ', null, { timeOut: 2000, progressBar: true, progressAnimation: 'increasing',positionClass: "toast-top-right"});
           return false;
        }
        return true;
     } 

    }
    
    @Pipe({ name: 'safe' })
    class SafePipe implements PipeTransform {
      constructor(private sanitizer: DomSanitizer) {}
      transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
    }

    @Pipe({ name: 'safeHtml' })
    class SafeHtmlPipe  implements PipeTransform {
      constructor(private sanitizer: DomSanitizer) {}
      transform(value) {
        return this.sanitizer.bypassSecurityTrustHtml(value);
      }
    } 
   
    @NgModule({
      declarations: [
        TemplateComponent,
        PlotlyComponent,
        EsriMapComponent,
        SafePipe,
        SafeHtmlPipe
      ],
      providers: [
        CanDeactivateGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        }
      ],
      imports: [
        SpreadSheetsModule,
        MbscModule,
        CommonModule,
        BrowserModule,
        FormsModule,
        RouterModule,
        NgxDatatableModule,
        CodemirrorModule,
        ChartsModule,
        NgxSelectModule,
        BrowserAnimationsModule,
        AngularMultiSelectModule,
        AceEditorModule,
        DataTablesModule,
        SpringSpinnerModule,
        HotTableModule,
        AtomSpinnerModule,
        PixelSpinnerModule,
        FingerprintSpinnerModule,
        CirclesToRhumbusesSpinnerModule,
        BreedingRhombusSpinnerModule,
        FlowerSpinnerModule,
        FulfillingBouncingCircleSpinnerModule,
        HalfCircleSpinnerModule,
        SelfBuildingSquareSpinnerModule,
        TableModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        ToastrModule.forRoot(),
        BsDropdownModule.forRoot(),
        TabsModule.forRoot(),
        ToastrModule.forRoot(),
        CarouselModule.forRoot(),
        CollapseModule.forRoot(),
        PaginationModule.forRoot(),
        PopoverModule.forRoot(),
        ProgressbarModule.forRoot(),
        TooltipModule.forRoot(),
        ModalModule.forRoot()
      ]
    })

    class TemplateModule {

      SystemClicked(event): void {
        console.log(event);
      }
    }

    if (this.viewContainer.length > 0) {
      this.viewContainer.remove();
    }

    this.compiler.clearCache();

    const mod = this.compiler.compileModuleAndAllComponentsSync(TemplateModule);
    const factory = mod.componentFactories.find((comp) =>
      comp.componentType === TemplateComponent
    );
    
    const component = this.viewContainer.createComponent(factory);
  }
}




// WEBPACK FOOTER //
// ./src/app/directives/dynamic-page/dynamic-page.directive.ts